<template>
    <div>
        <canvas id="myChart" width="400" height="400"></canvas>
    </div>

</template>
<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            lifestoryData: null,
            chartData: null,
        }
    },

    props: ['url'],

    mixins: [],

    computed: {
    },

    created() {
    },

    mounted() {
        this.getData();
    },

    watch: {
    },

    methods: {
        initialiseChart() {
            var ctx = document.getElementById('myChart').getContext('2d');

            this.chart = new Chart(ctx, {
                type: 'horizontalBar',
                data: this.chartData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                max: 10,
                            }
                        }],
                        YAxes: [{
                            barPercentage: 0.5,
                            barThickness: 6,
                            maxBarThickness: 8,
                            minBarLength: 2,
                            gridLines: {
                                offsetGridLines: true
                            }
                        }]
                    }
                }
            });
        },

        getData() {
            axios
                .get(this.url,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    this.lifestoryData = response.data.data;
                    this.prepareData();
                })
                .catch(error => {
                    console.log(error);
                });
        },

        prepareData() {
            var labels = [];
            var current = [];
            var aspirational = [];

            for (const key in this.lifestoryData) {
                if (this.lifestoryData.hasOwnProperty(key)) {
                    const element = this.lifestoryData[key];
                    labels.push(key);
                    current.push(element.current);
                    aspirational.push(element.aspirational);
                }
            }

            this.chartData = {
                labels: labels,
                datasets: [
                    {
                        label: 'Current Score',
                        data: current,
                        backgroundColor: 'rgba(140, 175, 196, 0.5)',
                        borderColor: 'rgba(140, 175, 196, 1)',
                        borderWidth: 1
                    },
                    {
                        label: 'Aspirational Score',
                        data: aspirational,
                        backgroundColor: 'rgba(255, 213, 121, 0.5)',
                        borderColor: 'rgba(255, 213, 121, 1)',
                        borderWidth: 1
                    },
                ]
            }

            this.initialiseChart();
        }
    },

    components: {
    }
}
</script>
